import React from "react";
import { Chart } from "react-google-charts";
import "./styles.scss";

// const colorRange1 = ["#0047FF", "#41FFFB", "#00FF5F", "#FFFC09", "#FF2200"];
const colorRange = ["#FF00EC", "#00FFC8", "#6BFF00", "#FFDD00"];

const colorRangeBlues = ["#131931", "#FFFFFF"];

// const colors {
//   bwhite:
// }
// const colorRangeBluesDM = [
//   "#0A2468",
//   "#021B5D",
//   "#001350",
//   "#000D40",
//   "#00082E",
//   "#000319",
//   "#000002",
// ];

const colorRangeBluesLM = [
  "#D2D6EB",
  "#A8B0D6",
  "#7E8BBF",
  "#5468A4",
  "#2C4588",
  "#0A2468",
];

export function loadingScreen() {
  return <div className="loading--wrapper">Loading chart</div>;
}

export function DataVizWrapper({ title, children }) {
  return (
    <div className="el-dataviz" id={title.replace(/\s/g, "").toLowerCase()}>
      <h3>{title}</h3>
      {children}
    </div>
  );
}

export function DataVizGoogle({ title, data }) {
  return (
    <>
      <div style={{ display: "flex", maxWidth: 900 }}>
        <Chart
          width={400}
          height={300}
          chartType="AreaChart"
          loader={loadingScreen()}
          data={[
            ["City", "2010 Population", "2000 Population"],
            ["New York City, NY", 8175000, 8008000],
            ["Los Angeles, CA", 3792000, 3694000],
            ["Chicago, IL", 2695000, 2896000],
            ["Houston, TX", 2099000, 1953000],
            ["Philadelphia, PA", 1526000, 1517000],
          ]}
          options={{
            colors: colorRangeBlues,
            legend: "none",
            hAxis: { title: "Year", titleTextStyle: { color: "#333" } },
            vAxis: { minValue: 0 },
            chartArea: {
              left: "10%",
              right: "30%",
              top: "10%",
              width: "60%",
              height: "40%",
            },

            backgroundColor: "transparent",
            strokeOpacity: 0,
          }}
          legendToggle
        />
      </div>
    </>
  );
}

export function DataVizAreaChart({ data, width, height }) {
  return (
    <Chart
      // width={width}
      // height={height}
      chartType="LineChart"
      loader={loadingScreen()}
      data={data}
      options={{
        colors: colorRange,
        fontName: "Poppins",
        backgroundColor: "transparent",
        strokeOpacity: 0,

        legend: {
          position: "none",
          maxLines: 2,
          textStyle: { color: "#fff" },
        },
        vAxis: {
          viewWindowMode: "explicit",
          baselineColor: "#90D0F8",
          viewWindow: {
            min: -100,
          },
          gridlines: {
            color: "transparent",
          },
          minorGridlines: {
            color: "transparent",
          },
          textStyle: { color: "#90D0F8", fontSize: "10px" },
        },
        hAxis: {
          format: "dd/MM HH:mm",
          textStyle: { color: "#90D0F8" },
          gridlines: {
            color: "#90D0F8",
          },
          minorGridlines: {
            color: "transparent",
          },
        },
        chartArea: {
          left: "10%",
          right: "5%",
          top: "15%",
          width: "90%",
          height: "60%",
        },
        curveType: "function",
        animation: {
          duration: 1000,
          easing: "out",
          startup: true,
        },
      }}
    />
  );
}
export function PieChart({ width, height }) {
  return (
    <Chart
      height="100%"
      chartType="PieChart"
      loader={loadingScreen()}
      data={[
        ["Task", "Hours per Day"],
        ["Lorem", 11],
        ["Ipsum", 6],
        ["Dolor", 4],
        ["Amet", 2],
      ]}
      options={{
        chartArea: { left: "10%", top: "20%", width: "80%", height: "70%" },
        colors: colorRangeBluesLM,
        pieHole: 0.4,
        pieSliceTextStyle: {
          color: "transparent",
        },
        pieSliceBorderColor: "transparent",
        backgroundColor: "transparent",
        legend: {
          position: "right",
          maxLines: 2,
          textStyle: { color: "#fff" },
        },
        strokeOpacity: 0,
        animation: {
          duration: 1500,
          easing: "InAndOut",
        },
      }}
      rootProps={{ "data-testid": "1" }}
    />
  );
}

// export function DataVizGoogle4({ title, data }) {
//   return (
//     <Chart
//       width={400}
//       height={300}
//       chartType="LineChart"
//       loader={loadingScreen()}
//       data={[["Date", "Delta-Min Prijs", "Delta-Max Prijs"]]}
//       options={{
//         colors: colorRange,
//         curveType: "function",
//         chartArea: {
//           left: "10%",
//           right: "10%",
//           top: "15%",
//           width: "80%",
//           height: "50%",
//         },
//         backgroundColor: "transparent",
//         strokeOpacity: 0,
//         intervals: { style: "area" },
//         legend: "none",
//       }}
//     />
//   );
// }

// API chart

// export function DexterChart({ data }) {
//   return (
//     <Chart
//       width={400}
//       height={300}
//       chartType="LineChart"
//       loader={loadingScreen()}
//       // data={[
//       //   ["Date", "Delta-Min Prijs", "Delta-Max Prijs"],
//       //   [new Date(2020, 5, 25, 0, 0, 0), 8, 0],
//       //   [new Date(2020, 5, 25, 1, 0, 0), -11, 0],
//       //   [new Date(2020, 5, 25, 2, 0, 0), -29, 8.32],
//       //   [new Date(2020, 5, 25, 3, 0, 0), 0, 219],
//       //   [new Date(2020, 5, 25, 4, 0, 0), 18, 12],
//       //   [new Date(2020, 5, 25, 5, 0, 0), 10, 86],
//       //   [new Date(2020, 5, 25, 6, 0, 0), 0, 16],
//       //   [new Date(2020, 5, 25, 7, 0, 0), 0, 20],
//       //   [new Date(2020, 5, 25, 8, 0, 0), 2, 115],
//       //   [new Date(2020, 5, 25, 9, 0, 0), 0, 35.32],
//       //   [new Date(2020, 5, 25, 10, 0, 0), 0, 12.32],
//       //   [new Date(2020, 5, 25, 11, 0, 0), 0, 12.32],
//       // ]}
//       data={data}
//       options={{
//         colors: colorRange,
//         fontName: "Poppins",
//         backgroundColor: "transparent",
//         strokeOpacity: 0,

//         legend: {
//           position: "none",
//           maxLines: 2,
//           textStyle: { color: "#fff" },
//         },
//         vAxis: {
//           viewWindowMode: "explicit",
//           baselineColor: "#90D0F8",
//           viewWindow: {
//             min: -100,
//           },
//           gridlines: {
//             color: "transparent",
//           },
//           minorGridlines: {
//             color: "transparent",
//           },
//           textStyle: { color: "#90D0F8", fontSize: "10px" },
//         },
//         hAxis: {
//           format: "dd/MM HH:mm",
//           textStyle: { color: "#90D0F8" },
//           gridlines: {
//             color: "#90D0F8",
//           },
//           minorGridlines: {
//             color: "transparent",
//           },
//         },
//         chartArea: {
//           left: "10%",
//           right: "10%",
//           top: "15%",
//           width: "80%",
//           height: "45%",
//         },
//         curveType: "function",
//         animation: {
//           duration: 1000,
//           easing: "out",
//           startup: true,
//         },
//       }}
//     />
//   );
// }
